import {
  getNameDescriptionTableColumn,
} from '@/utils/common/tableColumn'
// import i18n from '@/locales'
// import { currencyUnitMap } from '@/constants/currency'
import currencyRequest from '@Bill/mixins/currencyRequest'
// import { numerify } from '@/filters'

export default {
  mixins: [currencyRequest],
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        field: 'domain',
        hideField: true,
        edit: false,
        editDesc: false,
        showDesc: false,
        addBackup: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.domain }</side-page-trigger>
          )
        },
      }),
      // {
      //   field: 'amount',
      //   title: i18n.t('bill.text_141'),
      //   sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.amount, '0,0.00')}`
      //   },
      // },
      // {
      //   field: 'year_amount',
      //   title: i18n.t('bill.text_139'),
      //   // sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.year_amount, '0,0.00')}`
      //   },
      // },
    ]
  },
}
